import {TestState} from "../../interfaces/store/reducers/testState";
import {SET_ACTIVE_TEST_TYPE} from "../actions/availableActions";
import {SetActiveTestTypeAction} from "../../interfaces/store/test";
import {ContentType} from "../../enums/enums";

const initialState: TestState = {
    activeTestType: ContentType.AVAILABLE,
};

type AvailableActions = SetActiveTestTypeAction;

const testReducer = (state: TestState = initialState, action: AvailableActions): TestState => {
    switch (action.type) {
        case SET_ACTIVE_TEST_TYPE:
            return {
                ...state,
                activeTestType: action.payload,
            };
        default:
            return state;
    }
};

export default testReducer;
